// Real brand icons, served from the static assets already in
// public/icons/{openai,gemini-color,perplexity-color,claude-color,grok}.svg.

export function ChatGPTIcon() {
  return <img src="/icons/openai.svg" alt="" className="h-5 w-5" />;
}

export function GeminiIcon() {
  return <img src="/icons/gemini-color.svg" alt="" className="h-5 w-5" />;
}

export function PerplexityIcon() {
  return <img src="/icons/perplexity-color.svg" alt="" className="h-5 w-5" />;
}

export function ClaudeIcon() {
  return <img src="/icons/claude-color.svg" alt="" className="h-5 w-5" />;
}

export function GrokIcon() {
  return <img src="/icons/grok.svg" alt="" className="h-5 w-5" />;
}
